import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class AccountMoeinTransfer extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            documentItemsId: props.DocumentItemsId,
            data: null,
            loading: true,
            toMoeinId: this.getDefaultGuid(),
        };
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/get", { })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    transfer(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/account/moeintransfer", {
            documentItemsId: this.state.documentItemsId,
            toMoeinId: this.state.toMoeinId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("انتقال آرتیکل ها با موفقیت انجام پذیرفت");
                    if (this.state.caller.refreshData) this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" id="DocumentModalViewerContent">
                        <div className="panel panel-info center-block" style={{ "maxWidth": " none" }}>
                            <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                                <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">انتقال معین آرتیکل های انتخابی به معین جدید</h4>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12 mb-2" style={{color:"red"} }>
                                        <p>تعداد {this.state.documentItemsId.length} آرتیکل جهت تغییر معین انتخاب شده است</p>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="title1">انتخاب حساب معین جدید</label>
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={null}
                                                isMulti={false}
                                                placeholder="انتخاب حساب معین"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                                                onChange={e => this.state.toMoeinId = e.value}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <p className="text-red">توجه: با انجام این عملیات، کلیه آرتیکل های اسناد موقت سال مالی انتخابی به حساب مقصد انتخابی فوق منتقل خواهند شد</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={e => this.transfer(e)}>انتقال</button>
                                <a className="btn btn-warning" onClick={e => this.closeMe()} > انصراف</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}